<div class="min-h-dvh flex flex-col relative">
  <app-header class="sticky top-0 z-50"></app-header>
  <div class="flex-1">
    <router-outlet />
  </div>
  <app-footer />
</div>
